"use strict";

const IS_PRODUCTION = false;
const GMAP_API_KEY = "AIzaSyDez1pXp1nyswf9KglQKw2EmnXiqXSszpw";

let googleSheets = {
    company: "2022071734",
    company_areas_of_business: "1721887489",
    company_overseas_presence: "1003963993",
    company_cable_data: "1974381464",
    company_country: "202934436",
    company_region: "545924141",
    last_update: "1039321148",
};

if (IS_PRODUCTION) {
    googleSheets.spreadsheetID =
        "2PACX-1vSAb_0sjxVF9OGO-uXUXdWPYAyQU71XDuEVfvKCogP363zgxDezSDxiXuo0E0BOaRjoyELmgrcGsbl4"; // Production v2
    googleSheets.urlID = "1wSqXCidLZaN8yiBpKB-7ZR4TzUt0U1pvKYEzfCo_wec"; // Production v2
} else {
    googleSheets.spreadsheetID =
        "2PACX-1vSAb_0sjxVF9OGO-uXUXdWPYAyQU71XDuEVfvKCogP363zgxDezSDxiXuo0E0BOaRjoyELmgrcGsbl4"; // Production v3
    googleSheets.urlID = "1wSqXCidLZaN8yiBpKB-7ZR4TzUt0U1pvKYEzfCo_wec"; // Production v3
}


export { googleSheets, GMAP_API_KEY, IS_PRODUCTION };
